import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from './store/auth';

const Login = () => import('./views/Login.vue');
const Signup = () => import('./views/Signup.vue');
const AppShell = () => import('./components/AppShell.vue');
const ConnectionsList = () => import('./views/ConnectionsList.vue');
const ConnectionDetail = () => import('./views/ConnectionDetail.vue');
const NewConnection = () => import('./views/NewConnection.vue');

const routes = [
  { path: '/', redirect: { name: 'connections' } },
  { path: '/login', name: 'login', component: Login, meta: { guest: true } },
  { path: '/signup', name: 'signup', component: Signup, meta: { guest: true } },
  {
    path: '/',
    component: AppShell,
    meta: { requiresAuth: true },
    children: [
      { path: 'connections', name: 'connections', component: ConnectionsList },
      {
        path: 'connections/new',
        name: 'connections.new',
        component: NewConnection,
      },
      {
        path: 'connections/:id',
        name: 'connections.show',
        component: ConnectionDetail,
        props: true,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

router.beforeEach(to => {
  const auth = useAuthStore();
  auth.restoreSession();

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'login', query: { next: to.fullPath } };
  }
  if (to.meta.guest && auth.isAuthenticated) {
    return { name: 'connections' };
  }
  return true;
});

export default router;
